import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { BehaviorService } from '@_services/Behavior.service';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
  selector: 'app-name',
  templateUrl: './name.component.html',
  styleUrls: ['./name.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NameComponent implements OnInit, OnDestroy {
  @Input() SettingForm: FormGroup;
  isLoadingResults: boolean = false;
  @Input() errorWarningData: any;
  addData: any;
  class: boolean;
  sub: Subscription;
  clickedBtn: string = 'name';
  public isspiner: boolean = false;
  currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
  private _unsubscribeAll$: Subject<void> = new Subject();
  constructor(
    private _mainAPiServiceService: MainAPiServiceService,
    private behaviorService: BehaviorService,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef,
  ) {
    localStorage.setItem('istrackid', 'SystemSettingNameComponent');
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.sub = this.behaviorService.permissionCheckforHeight$.subscribe((data: any) => {
      this.class = data;
      this.cd.markForCheck();
    });
    this.loadData();
    // this.isLoadingResults = true;
    // this._mainAPiServiceService.getSetData({EXCLUDESYSTEMACCOUNTS :true,EXCLUDEINVOICETEMPLATESETTINGS:true}, 'GetSystem').subscribe(response => {
    //   if (response.CODE == 200 && response.STATUS == "success") {
    //     this.addData = response.DATA.SYSTEM.ADDRESSGROUP.POSTALADDRESSGROUP;
    //     this.behaviorService.loadingSystemSetting('name');
    //
    //   }
    // }, error => {
    //   this.toastr.error(error);
    // });
  }

  /**
   * load data of organizational details of system settings
   */
  loadData() {
    // this.isLoadingResults = true;
    this._mainAPiServiceService
      .getSetData(
        {
          Action: 'GetData',
          Filters: { GroupName: 'OrganisationalDetails' },
        },
        'system',
      )
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            // this.isLoadingResults = false;
            let name = JSON.parse(localStorage.getItem('currentUser'));
            name.UserName = response.DATA.RECORDS.BARRISTERSNAME;
            let odData = response.DATA.RECORDS;
            this.addData = response.DATA.RECORDS;
            this.SettingForm.controls['BARRISTERSNAME'].setValue(odData.BARRISTERSNAME);
            this.SettingForm.controls['ABN'].setValue(odData.ABN);
            this.SettingForm.controls['FAMILYLAWCOURTID'].setValue(odData.FAMILYLAWCOURTID);
            this.SettingForm.controls['LRSBOXNUMBER'].setValue(odData.LRSBOXNUMBER);
            if (this.currentUser.PRODUCTTYPE == 'Barrister') {
              this.SettingForm.controls['CHAMBERS'].setValue(odData.CHAMBERS);
            }
            this.SettingForm.controls['ADDRESS1'].setValue(odData.ADDRESS1);
            this.SettingForm.controls['ADDRESS2'].setValue(odData.ADDRESS2);
            this.SettingForm.controls['POSTCODE'].setValue(odData.POSTCODE);
            this.SettingForm.controls['SUBURB'].setValue(odData.SUBURB);
            this.SettingForm.controls['STATE'].setValue(odData.STATE);

            this.SettingForm.controls['POSTALADDRESS1'].setValue(odData.POSTALADDRESS1);
            this.SettingForm.controls['POSTALADDRESS2'].setValue(odData.POSTALADDRESS2);
            this.SettingForm.controls['POSTALPOSTCODE'].setValue(odData.POSTALPOSTCODE);
            this.SettingForm.controls['POSTALSUBURB'].setValue(odData.POSTALSUBURB);
            this.SettingForm.controls['POSTALSTATE'].setValue(odData.POSTALSTATE);

            this.SettingForm.controls['DXNUMBER'].setValue(odData.DXNUMBER);
            this.SettingForm.controls['DXSUBURB'].setValue(odData.DXSUBURB);

            this.SettingForm.controls['FAX1'].setValue(odData.FAX1);
            this.SettingForm.controls['FAX2'].setValue(odData.FAX2);
            this.SettingForm.controls['PHONE1'].setValue(odData.PHONE1);
            this.SettingForm.controls['PHONE2'].setValue(odData.PHONE2);

            this.SettingForm.controls['EMAIL'].setValue(odData.EMAIL);
            this.SettingForm.controls['WWW'].setValue(odData.WWW);
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * save the data of organizational details
   */
  saveOD() {
    this.isspiner = true;
    this.cd.markForCheck();
    let data = {
      GroupName: 'OrganisationalDetails',
      BARRISTERSNAME: this.SettingForm.controls.BARRISTERSNAME.value,
      ABN: this.SettingForm.controls.ABN.value,
      FAMILYLAWCOURTID: this.SettingForm.controls.FAMILYLAWCOURTID.value,
      LRSBOXNUMBER: this.SettingForm.controls.LRSBOXNUMBER.value,
      ADDRESS1: this.SettingForm.controls.ADDRESS1.value,
      ADDRESS2: this.SettingForm.controls.ADDRESS2.value,
      SUBURB: this.SettingForm.controls.SUBURB.value,
      STATE: this.SettingForm.controls.STATE.value,
      POSTCODE: this.SettingForm.controls.POSTCODE.value,
      POSTALADDRESS1: this.SettingForm.controls.POSTALADDRESS1.value,
      POSTALADDRESS2: this.SettingForm.controls.POSTALADDRESS2.value,
      POSTALSUBURB: this.SettingForm.controls.POSTALSUBURB.value,
      POSTALSTATE: this.SettingForm.controls.POSTALSTATE.value,
      POSTALPOSTCODE: this.SettingForm.controls.POSTALPOSTCODE.value,
      DXNUMBER: this.SettingForm.controls.DXNUMBER.value,
      DXSUBURB: this.SettingForm.controls.DXSUBURB.value,
      PHONE1: this.SettingForm.controls.PHONE1.value,
      PHONE2: this.SettingForm.controls.PHONE2.value,
      FAX1: this.SettingForm.controls.FAX1.value,
      FAX2: this.SettingForm.controls.FAX2.value,
      EMAIL: this.SettingForm.controls.EMAIL.value,
      WWW: this.SettingForm.controls.WWW.value,
    };
    if (this.currentUser.PRODUCTTYPE == 'Barrister') {
      data['CHAMBERS'] = this.SettingForm.controls.CHAMBERS.value;
    }
    let data1 = { Action: 'Update', Data: data };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspiner = false;
            this.behaviorService.DELIVERABLES$.next(
              localStorage.getItem('set_active_DELIVERABLES'),
            );
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspiner = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * This function is used to trigger Some event data value
   */
  triggerSomeEvent(f: any) {
    let ADDRESS1 = this.SettingForm.get('ADDRESS1').value;
    let ADDRESS2 = this.SettingForm.get('ADDRESS2').value;
    let SUBURB = this.SettingForm.get('SUBURB').value;
    let STATE = this.SettingForm.get('STATE').value;
    let POSTCODE = this.SettingForm.get('POSTCODE').value;

    if (f.value.SAMECOPYADDRESS == true) {
      this.SettingForm.controls['POSTALADDRESS1'].setValue(ADDRESS1);
      this.SettingForm.controls['POSTALADDRESS2'].setValue(ADDRESS2);
      this.SettingForm.controls['POSTALSUBURB'].setValue(SUBURB);
      this.SettingForm.controls['POSTALSTATE'].setValue(STATE);
      this.SettingForm.controls['POSTALPOSTCODE'].setValue(POSTCODE);
    } else {
      this.SettingForm.controls['POSTALADDRESS1'].setValue(this.addData.POSTALADDRESS1);
      this.SettingForm.controls['POSTALADDRESS2'].setValue(this.addData.POSTALADDRESS2);
      this.SettingForm.controls['POSTALPOSTCODE'].setValue(this.addData.POSTALPOSTCODE);
      this.SettingForm.controls['POSTALSUBURB'].setValue(this.addData.POSTALSUBURB);
      this.SettingForm.controls['POSTALSTATE'].setValue(this.addData.POSTALSTATE);
    }
  }
}
